"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formData = formData;
exports.assertFormData = assertFormData;
exports.isFormData = isFormData;
exports.validateFormData = validateFormData;
exports.query = query;
exports.assertQuery = assertQuery;
exports.isQuery = isQuery;
exports.validateQuery = validateQuery;
exports.headers = headers;
exports.assertHeaders = assertHeaders;
exports.isHeaders = isHeaders;
exports.validateHeaders = validateHeaders;
exports.parameter = parameter;
exports.createFormData = createFormData;
exports.createAssertFormData = createAssertFormData;
exports.createIsFormData = createIsFormData;
exports.createValidateFormData = createValidateFormData;
exports.createQuery = createQuery;
exports.createAssertQuery = createAssertQuery;
exports.createIsQuery = createIsQuery;
exports.createValidateQuery = createValidateQuery;
exports.createHeaders = createHeaders;
exports.createAssertHeaders = createAssertHeaders;
exports.createIsHeaders = createIsHeaders;
exports.createValidateHeaders = createValidateHeaders;
exports.createParameter = createParameter;
const NoTransformConfigurationError_1 = require("./transformers/NoTransformConfigurationError");
/** @internal */
function formData() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.formData");
}
/** @internal */
function assertFormData() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.assertFormData");
}
/** @internal */
function isFormData() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.isFormData");
}
/** @internal */
function validateFormData() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.validateFormData");
}
/** @internal */
function query() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.query");
}
/** @internal */
function assertQuery() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.assertQuery");
}
/** @internal */
function isQuery() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.isQuery");
}
/** @internal */
function validateQuery() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.validateQuery");
}
/** @internal */
function headers() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.headers");
}
/** @internal */
function assertHeaders() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.assertHeaders");
}
/** @internal */
function isHeaders() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.isHeaders");
}
/** @internal */
function validateHeaders() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.validateHeaders");
}
/** @internal */
function parameter() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.parameter");
}
/** @internal */
function createFormData() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.createFormData");
}
/** @internal */
function createAssertFormData() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.createAssertFormData");
}
/** @internal */
function createIsFormData() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.createIsFormData");
}
/** @internal */
function createValidateFormData() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.createValidateFormData");
}
/** @internal */
function createQuery() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.createQuery");
}
/** @internal */
function createAssertQuery() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.createAssertQuery");
}
/** @internal */
function createIsQuery() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.createIsQuery");
}
/** @internal */
function createValidateQuery() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.createValidateQuery");
}
/** @internal */
function createHeaders() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.createHeaders");
}
/** @internal */
function createAssertHeaders() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.createAssertHeaders");
}
/** @internal */
function createIsHeaders() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.createIsHeaders");
}
/** @internal */
function createValidateHeaders() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.createValidateHeaders");
}
/** @internal */
function createParameter() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("http.createParameter");
}
//# sourceMappingURL=http.js.map